import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  getUnderlyingPath,
  MenuTabInterface,
} from '@main/internationalization';
import { PageType, PATHNAME_TO_PAGE_TYPE } from '@main/pc-types';
import { selectRequiredPrivacyCenter } from '@main/privacy-center/src/containers/App/selectors';
import { selectPolicies } from '@main/privacy-center/src/pages/Policies/selectors';
import { switchCase } from '@main/utils';

/**
 * gets the current side menu tabs from the page pathname
 *
 * @returns the list of tab objects for the current page
 */
export function useSideMenuTabs(): MenuTabInterface[] {
  const policies = useSelector(selectPolicies);
  const { pathname } = useLocation();
  const { locale } = useIntl();
  const { pages } = useSelector(selectRequiredPrivacyCenter);
  const pageType =
    PATHNAME_TO_PAGE_TYPE[getUnderlyingPath(pathname).underlyingPath];
  const page = pages.find((p) => p.type === pageType);
  const pageToTabs = switchCase<MenuTabInterface[], [], PageType>({
    [PageType.HomePage]: [],
    // filter policies for disabledLocales
    [PageType.Policies]: () =>
      policies.filter((policy) =>
        !policy.disabledLocales || policy.disabledLocales.length === 0
          ? true
          : !policy.disabledLocales.includes(locale),
      ),
    [PageType.TrackingTechnologies]: [],
    [PageType.ManageYourPrivacy]: [],
    [PageType.RequestsProcessedReporting]: [],
    [PageType.CommunicationsPreferences]: [],
    [PageType.SaleOfInfo]: [],
  })([]);
  return page ? pageToTabs(page.type) : [];
}
